import { Modal } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { TradePlanData } from '../../../../../../../classes/tradePlan/tradePlanData';
import { useTradePlanFormStore } from '../../../../../../../classes/tradePlan/tradePlanProvider';
import { colors } from '../../../../../../../colorVars';
import { ModuleHeader } from '../../../../../../atomic/atomicComponentLibrary/moduleHeader/ModuleHeader';
import { Body3, Body4 } from '../../../../../../atomic/text/Text';
import { OptionData } from '../optionChains/optionType';
import { SelectOptionModalHeader } from './SelectOptionModalHeader';
import style from './SelectOptionsModal.module.css';
import { SelectOptionsModalRow } from './SelectOptionsModalRow';

type Props = {
  open: boolean;
  handleClose: () => void;
};

export const SelectOptionsModal = observer(({ open, handleClose }: Props) => {
  const tradePlanForm: TradePlanData = useTradePlanFormStore();
  const optionManagement = tradePlanForm.optionManagement;
  const dates = Object.keys(optionManagement.optionChains) ?? [];
  return (
    <Modal open={open} onClose={handleClose}>
      <div className={style.container}>
        <ModuleHeader title="Select Options" clickHandler={handleClose}/>
        <div className={style.tables}>
          <div className={style.calls}>
            <Body3 color={colors.lightGrey}>Calls</Body3>
            {dates.map((date) => (
              <table className={style.table} key={date + 'calls'}>
                <SelectOptionModalHeader type="calls" date={date} />
                <tbody className={style.tbody}>
                  {optionManagement.optionChains[date]?.calls.map(
                    (chain: OptionData) => (
                      <SelectOptionsModalRow date={date} key={chain.symbol} chain={chain} />
                    )
                  )}
                </tbody>
              </table>
            ))}
          </div>
          <div className={style.puts}>
            <Body3 color={colors.lightGrey}>Puts</Body3>
            {dates.map((date) => (
              <table key={date + 'puts'} className={style.table}>
                <SelectOptionModalHeader type="puts" date={date} />
                <tbody className={style.tbody}>
                  {optionManagement.optionChains[date]?.puts.map(
                    (chain: OptionData) => (
                      <SelectOptionsModalRow date={date} key={chain.symbol} chain={chain} />
                    )
                  )}
                </tbody>
              </table>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
});
